<template>
    <div class="grcform">
    <GrcDB ref="GRCDB"></GrcDB>    
    <GrcDocDisplayer ref="DocDisplayer"></GrcDocDisplayer>
    <GrcDialog ref="Dialog"
        v-on:popupopened="SetPopupRef('Dialog')"
        v-on:popupclosed="SetPopupRef('')"
    ></GrcDialog>

    <div style="width:100%; box-sizing:border-box; padding-bottom: 0px; margin-bottom: 20px; display: inline-block;">
      <div style="width:100%; box-sizing:border-box;">
            <div class="igeny_pageheader">
                <div class="igeny_pageheader_col1">
                    <div class="grc_sectionheader" style="margin-top:0px;">
                        <h2 class="painted_header_h2 color3"><span><b>Kritikus keret igénylés</b></span></h2>
                    </div>
                </div>
                <div class="igeny_pageheader_col2">
                    <span class="painted_linkbutton2 color4"><span>{{UgyfelNev}}</span></span>
                </div>
            </div>

      </div>
    </div>

    <div style="width:100%; box-sizing:border-box; text-align:left;" v-show="IsEnabled==0" v-html="DisabledText">
        
    </div>

    <div style="width:100%; box-sizing:border-box; text-align:left;" v-show="(IsEnabled==1)&&(MainStep==0)">
        <div style="width:100%; box-sizing:border-box; text-align:justify;" v-html="MainStep0_infotext">
            
        </div>

        <div class="btncont" style="margin-top:30px;">

            <span @click="GoTo_MainStep(1)" class="painted_linkbutton2 color3"><span>Keret igénylés<i class='fal fa-chevron-right' style="margin-left:10px;"></i></span></span>                    

        </div>

    </div>


    <div style="width:100%; box-sizing:border-box;" v-show="(IsEnabled==1)&&(MainStep==1)">
      <div style="padding-bottom: 20px; width:100%; box-sizing:border-box;">

        <div class="igeny_pagecontent">

            <div class="StepProgress_cont">
                <GrcStepProgress ref="StepProgress" />
            </div>

            <div class="innerform_cont" v-show="innerform==5">
                <span class="painted_linkbutton2 color4"><span>Diagnózis</span></span>
                <br><br>

                <div class="innerform_col50">

                    <GrcCombo ref="cboEllatasok" v-model="cboEllatasok" grc_labeltext="Ellátás:"
                    grc_labelmode="above" grc_labelwidth="80px" grc_dropdownminwidth="300"  
                    grc_keyfield="id" grc_displayfield="Megnevezes"
                    grc_readonly="false"
                    v-bind:grc_dropdown_columns="[{fieldname:'Megnevezes', width:'100%', cutlongtext:'true'}]"
                    v-on:dropdownopened="SetPopupRef('cboEllatasok')"
                    v-on:dropdownclosed="SetPopupRef('')"
                    v-on:grc-keydown-enter="SetControlToFocus('');"
                    v-on:innerindexbroadcast="cboEllatasok_InnerIndexBroadcasted"
                    style="margin-bottom:20px;"
                    />

                    <div class="kritikus_datum_infotext" style="margin-bottom:10px;">Ide a biztosítási esemény dátumát kérjük beírni, melynek meghatározását a kiválasztott kritikus betegség információs ablakában olvashatja.</div>


                    <GrcDate ref="txtDiagnozisDatum" v-model="txtDiagnozisDatum" grc_dateformat="ymd" grc_sep="." 
                    grc_labeltext="Diagnózis dátuma:" grc_labelmode="above" grc_labelwidth="200px" grc_readonly="false"
                    v-on:grc-keydown-enter="SetControlToFocus('');"
                    v-on:dropdownopened="SetPopupRef('txtDiagnozisDatum')"
                    v-on:dropdownclosed="SetPopupRef('')"
                    style="max-width:300px; margin-bottom:20px;"
                    />


                    <div class="longlabel" style="margin-top:20px; margin-bottom:8px;">Diagnózis rövid leírása:</div>
                    <GrcTextArea ref="txtDiagnozisLeiras"
                    grc_labeltext="" grc_labelmode="nolabel" grc_labelwidth="200px" 
                    grc_areaheight="150px"
                    style="margin-bottom:20px;"
                    />



                </div>
                <div class="innerform_col50 colpad_0_8">
                    <div class="VizsgalatInfoText" v-html="EllatasInfoText" v-show="EllatasInfoText!=''"></div>
                </div>



                <div class="btncont" style="margin-top:30px;">

                    <span @click="GoTo_MainStep(0)" class="painted_linkbutton2 color7" style="margin:4px;"><span><i class='fal fa-chevron-left' style="margin-right:10px;"></i>Vissza</span></span>
                    <span @click="btnStepTo(10)" class="painted_linkbutton2 color3" style="margin:4px;"><span>Tovább<i class='fal fa-chevron-right' style="margin-left:10px;"></i></span></span>                    

                </div>


            </div>




            <div class="innerform_cont" v-show="innerform==10">
                <span class="painted_linkbutton2 color4"><span>Orvosi dokumentumok feltöltése</span></span>
                <br><br>


                    <div class="general_infotext" style="margin: 10px 0px 20px 0px; text-align:justify;" v-html="DokumentumInfoText">
                    </div>

                    <div class="VizsgalatInfoText" v-html="EllatasInfoText" v-show="EllatasInfoText!=''"></div>

                    <div style="width:100%; box-sizing:border-box; margin-top: 20px;">
                        <GrcDocMultiSelect ref="docs" :grc_allowed_extensions="AllowedExtensions" :grc_maxfiles="MaxFiles" :grc_shownoti="ShowNoti" />
                    </div>

  

                <div class="btncont" style="margin-top:30px;">
                    <span @click="btnStepTo(5)" class="painted_linkbutton2 color7" style="margin:4px;"><span><i class='fal fa-chevron-left' style="margin-right:10px;"></i>Vissza</span></span>

                    <span @click="btnStepTo(20)" class="painted_linkbutton2 color3" style="margin:4px;"><span>Tovább<i class='fal fa-chevron-right' style="margin-left:10px;"></i></span></span>

                </div>
            </div>





            <div class="innerform_cont" v-show="innerform==20">
                <span class="painted_linkbutton2 color4"><span>Áttekintés és mentés</span></span>
                <br><br>


                <table style="width:100%; margin-bottom:20px;" cellspacing="0" cellpadding="0">
                    <tr>
                        <td style="text-align:center; font-weight:500; font-size:20px;">{{Osszesito.Igenylo}}</td>
                    </tr>
                    <tr>
                        <td style="text-align:center;padding-top: 10px;"><i>- kritikus keret igénylés -</i></td>
                    </tr>
                </table>

                <div style="width:100%; box-sizing:border-box; font-weight:500; text-align:left; margin: 20px 0px 10px 0px;">
                    Diagnózis: <span style="font-weight:normal;">{{Osszesito.DiagnozisDatum}}</span>
                </div>


                <div style="width:100%; box-sizing:border-box; font-weight:500; text-align:left; margin: 20px 0px 10px 0px;">
                    Diagnózis rövid leírása:
                </div>
                <div style="width:100%; box-sizing:border-box; font-weight:normal; text-align:justify;" v-html="Osszesito.DiagnozisLeiras"></div>

                <div style="width:100%; box-sizing:border-box; font-weight:500; text-align:left; margin: 20px 0px 10px 0px;">
                    Milyen ellátással kapcsolatban igényli a keretet?
                </div>
                <div style="width:100%; box-sizing:border-box; font-weight:normal; text-align:justify;" v-html="Osszesito.EllatasNev"></div>


                <div class="osszesito_box_cont">

                        <div class="osszesito_box_col">
                            <div class="osszesito_box_col_header">Feltöltendő fájlok:</div>

                            <div class="osszesito_box_col_content" v-show="Files.length==0">Nem választott ki fájlt</div>

                            <div style="width:100%; box-sizing:border-box; font-weight:normal; text-align:left;" v-show="Files.length>0">
                                <div style="width:100%; box-sizing:border-box; font-weight:normal; text-align:left; padding-left:10px;"
                                v-for="(fileitem, fileindex) in Files" :key="fileindex">{{fileitem.FileName}}</div>
                            </div>
                        </div>

                </div>




    

                <div class="btncont" style="margin-top:30px;">

                    <span @click="btnStepTo(10)" class="painted_linkbutton2 color7" style="margin:4px;"><span><i class='fal fa-chevron-left' style="margin-right:10px;"></i>Vissza</span></span>

                    <span @click="btnMentes" class="painted_linkbutton2 color3" style="margin:4px;"><span><i class='fal fa-check' style="margin-right:10px;"></i>Mentés</span></span>

                </div>
            </div>


        </div> <!-- igeny_pagecontent -->

      </div>
    </div>





    
    </div>
</template>

<script>
import axios from "axios";
import GrcButton from '../GrcComponents/GrcButton.vue'
import GrcDB from '../GrcComponents/GrcDB.vue'
import GrcDialog from '../GrcComponents/GrcDialog.vue'
import GrcCombo from '../GrcComponents/GrcCombo.vue'
import GrcText from '../GrcComponents/GrcText.vue'
import GrcCheckboxMobile from '../GrcComponents/GrcCheckboxMobile.vue'
import GrcDate from '../GrcComponents/GrcDate.vue'
import GrcTajszam from '../GrcComponents/GrcTajszam.vue'
import GrcIrszam from '../GrcComponents/GrcIrszam.vue'
import GrcTextArea from '../GrcComponents/GrcTextArea.vue'
import GrcStepProgress from '../GrcComponents/GrcStepProgress.vue'
import GrcAutoComplete from '../GrcComponents/GrcAutoComplete.vue'
import GrcDocDisplayer from '../GrcComponents/GrcDocDisplayer.vue'
import GrcDocMultiSelect from '../GrcComponents/GrcDocMultiSelect.vue'

export default {
  name: 'frmkritikusigenyles',
  components: {
      GrcButton,
      GrcDB,
      GrcDialog,
      GrcCombo,
      GrcText,
      GrcCheckboxMobile,
      GrcDate,
      GrcTajszam,
      GrcIrszam,
      GrcTextArea,
      GrcStepProgress,
      GrcAutoComplete,
      GrcDocDisplayer,
      GrcDocMultiSelect,

  },
  props: {
  },
  data () {
      return {
        WSPREFIX: "frmKritikusIgenyles_",
        UgyfelID:0,
        UgyfelNev:"",
        innerform:-1,

        Files: [],
        MaxWidth:1000,
        MaxHeight:1500,
        MaxFileCount:10,


        Osszesito: { Igenylo:"", DiagnozisDatum:"", DiagnozisLeiras:"", EllatasNev:"",  },


        AllowedExtensions:"pdf, jpg, png",
        ShowNoti:"false",
        MaxFiles:"-1",

        ELLATASOK:[],
        cboEllatasok:0,
        txtDiagnozisDatum:"",
        EllatasInfoText:"",
        DokumentumInfoText:"",

        IsEnabled:-1,
        DisabledText:"",
        MainStep:0,
        MainStep0_infotext:"",


        
      }
  },
  model: {
  },  
  methods:{

    GoTo_MainStep(pValue)
    {
        this.MainStep = pValue;
        this.scrollToTop();
    },

    cboEllatasok_InnerIndexBroadcasted(pIndex)
    {
        let TextbookRef = this.ELLATASOK[pIndex].TextbookRef;
        if (TextbookRef == "") { TextbookRef = "Ellatas_DefaultInfoText"; }

        let s = "";

        if (TextbookRef != "")
        {
            s = this.GetTextBookItem(TextbookRef);
        }

        this.EllatasInfoText = s;
    },



    SetPopupRef(pRef)
    {
        gPopupControlName = pRef;
    },

    scrollToTop() { window.scrollTo(0,0); },


    GetTextBookItem(pCompName)
    {
        return grcmain_GetTextBookItem("frmKritikusIgenyles", pCompName);
    },

    SetLang()
    {
        this.DokumentumInfoText = this.GetTextBookItem("Dokumentum_InfoText");
        this.MainStep0_infotext = this.GetTextBookItem("MainStep0_infotext");

    },

    SetControlToFocus(pNextComp)
    {
        if (pNextComp == "") { return; }
        this.$refs[pNextComp].SetFocus();
    },


    HideErrors()
    {
        
    },



      async btnStepTo(pStepIndex)
      {
          this.HideErrors();

          if ((this.innerform == 5)&&(pStepIndex==10))
          {
            if (this.$refs.cboEllatasok.GetValue() == 0)
            {
                this.ShowResult("Kérjük válassza ki az ellátást!", 200);
                return;
            }

            if (this.$refs.txtDiagnozisDatum.IsValid(false) == false)
            {
                this.ShowResult("Kérjük adja meg a diagnózis dátumát!", 200);
                return;
            }

            if (this.$refs.txtDiagnozisDatum.GetText() < "2023.04.01")
            {
                this.ShowResult("Az Ön betegségét 2023.03.31-e előtt diagnosztizálták, ezért kritikus betegség keretigénylését "
                +"az UNION-Érted Ellátásszervezőhöz kell benyújtania. A részleteket a főoldalon a "
                +"<a href='https://premiumellatas.hu/main/kritikus-betegseg-fedezet-igenyles' target='_blank'>További információk</a> menüpont alatt olvashatja.", 300);
                return;
            }



            var DL = this.$refs.txtDiagnozisLeiras.GetText();
            DL = DL.replace(/(\r\n|\n|\r)/gm, "");

            if (DL.length < 3)
            {
                this.ShowResult("Kérjük írja le néhány szóban a diagnózist!", 200);
                return;
            }

          }

          if ((this.innerform == 10)&&(pStepIndex==20))
          {

              if (this.$refs.docs.GetFileCount() == 0)
              {
                this.ShowResult("Legalább egy dokumentum feltöltése kötelező!", 200);

                return;
              }

              this.GenerateOsszesito();
          }          




        this.innerform = pStepIndex;
        this.scrollToTop();

        var StepProgressValue = 1;

        if (pStepIndex == 5) { StepProgressValue = 1; }
        if (pStepIndex == 10) { StepProgressValue = 2; }
        if (pStepIndex == 20) { StepProgressValue = 3; }

        this.$refs.StepProgress.SetValue(StepProgressValue);
      },

      GenerateOsszesito()
      {
        this.Files = this.$refs.docs.GetFileNames();

        this.Osszesito.Igenylo = this.UgyfelNev;

        var DL = this.$refs.txtDiagnozisLeiras.GetText();
        DL = DL.replace(/(\r\n)/gm, "<br>");
        DL = DL.replace(/(\n|\r)/gm, "<br>");



        this.Osszesito.DiagnozisDatum = this.$refs.txtDiagnozisDatum.GetText();
        this.Osszesito.DiagnozisLeiras = DL;

        this.Osszesito.EllatasNev = this.$refs.cboEllatasok.GetText();
       


      },


      async Mentes()
      {
          this.$refs.GRCDB.ShowLoading(false);

            var DL = this.$refs.txtDiagnozisLeiras.GetText();
            DL = DL.replace(/(\r\n)/gm, "<br>");
            DL = DL.replace(/(\n|\r)/gm, "<br>");



          var pFajlok = "";

          if (this.$refs.docs.GetFileCount() > 0)
          {
            var UploadRes = await this.$refs.docs.UploadFiles(1);
            if (UploadRes.Success == false) 
            { 
                this.$refs.GRCDB.HideLoading();
                await this.ShowResult("A dokumentum feltöltés előkészítése sikertelen!", 250);
                return;
            }
            
            pFajlok = pFajlok + "<DOCS>"
            +"<UploadID><![CDATA["+UploadRes.UploadID+"]]></UploadID>"
            +"<Megjegyzes><![CDATA["+UploadRes.Megjegyzes+"]]></Megjegyzes>"
            +"</DOCS>";

            pFajlok = "<NewDataSet>" + pFajlok + "</NewDataSet>";

          } // ha van fajl


        var QP = {
          sSessionID: "[APPSESSIONID]",
          iUgyfelID: this.UgyfelID,
          iEllatasID: this.$refs.cboEllatasok.GetValue(),
          sDiagnozisDatum: this.$refs.txtDiagnozisDatum.GetText(),
          sDiagnozisLeiras: DL,
          sFajlok: pFajlok,
        };
        var Q;
        await this.$refs.GRCDB.GetData("frmKritikusIgenyles_Save", QP).then(res => { Q = res; });

        if (Q.APPERR[0].ERR != "")
        {
            this.$refs.GRCDB.HideLoading();
            await this.ShowResult(Q.APPERR[0].ERR, 250);
            return;
        }

        this.$refs.GRCDB.HideLoading();

        await this.ShowResult(Q.RESULT[0].strResult, 300).then(res => 
        { 
            if (Q.RESULT[0].intResult == 1)
            {
                document.location = "dashboard";
            }
        });               

      },

      GetFajlXml()
      {
        if (this.Files.length == 0) { return ""; }

        var res = "<NewDataSet>";
        for(var i=0; i<this.Files.length; i++)
        {
            var ext = grcmain_getFileExtension(this.Files[i].filename.toLowerCase());
            if (ext == "jpeg") { ext = "jpg"; }

            res = res 
            +"<FAJL>"
            + "<FajlNev>"+this.Files[i].filename+"</FajlNev>"
            + "<FajlAdat>"+this.Files[i].ResizedData+"</FajlAdat>"
            + "<Kiterjesztes>"+ext+"</Kiterjesztes>"
            +"</FAJL>";
        }
        res = res + "</NewDataSet>";

        return res;
      },



      btnMentes()
      {
          this.Mentes();
      },



      async Init()
      {
 
        this.$refs.StepProgress.Init([ {text: "Diagnózis"},  {text:"Orvosi dokumentumok"}, {text:"Áttekintés"} ]);
        
        
        this.UgyfelID = gDashboardUgyfelID;


        this.$refs.GRCDB.ShowLoading(false);

        var QP = {
          sSessionID: "[APPSESSIONID]",
          iUgyfelID: this.UgyfelID
        };
        var Q;
        await this.$refs.GRCDB.GetData("frmKritikusIgenyles_Init", QP).then(res => { Q = res; });

        if (Q.APPERR[0].ERR != "")
        {
            this.$refs.GRCDB.HideLoading();
            await this.ShowResult(Q.APPERR[0].ERR, 250);
            return;
        }

        this.$refs.GRCDB.HideLoading();

        this.UgyfelNev = Q.RESULT[0].UgyfelNev;

        if (Q.RESULT[0].IsEnabled == 0)
        {
            this.IsEnabled = 0;
            this.DisabledText = Q.RESULT[0].DisabledText;
            return;
        }

        this.IsEnabled = Q.RESULT[0].IsEnabled;

        this.ELLATASOK = Q.ELLATASOK;

        this.$refs.cboEllatasok.SetDataSource(Q.ELLATASOK);
        this.$refs.cboEllatasok.SetValue(0);

        this.innerform = 5;

      },


    async ShowResult(pText, pHeight)
    {
        var DialogResult = "";
        var p = grccomp_dialog_alert_GetDefaults(grcmain_GetTextBookItem("tech", "informacio"), pText);             
        p.height = pHeight;
        p.width = 400;
        p.padding_top = -1;
        if (grccomp_getScreenSize().width < 400) { p.width = 300; }
        await this.$refs.Dialog.ShowDialog(p).then(res => 
        { 
            DialogResult = res; 
            //this.Init();
        });               
    },


  },
  created()
  {

  },
  mounted()
  {
    if (gAppInitDone)
    {
      this.SetLang();
      this.Init();
    }
  }

}


</script>


<style scoped>

.igenypage_header
{
    box-sizing: border-box;
    font-size: 15px;
    line-height: 20px;
    font-weight: normal;
    text-align: left;
    margin-bottom: 20px;

    background-color: var(--premgreen);
    color: #fff;
    font-weight: normal;
    display: inline-block;
    padding: 8px;
    border-radius: 3px;    
    margin-left: 10px;
}


.innerform_cont
{
    width:100%;
    box-sizing: border-box;
    font-size: 15px;
    line-height: 20px;
    font-weight: normal;
    text-align: left;
    padding:0px;
}

.innerform_col50
{
    width:50%;
    box-sizing: border-box;
    font-size: 15px;
    line-height: 20px;
    font-weight: normal;
    text-align: left;
    padding:0px 0px;
    vertical-align: top;
    display:inline-block;
}



.innerform_header
{
    width:100%;
    box-sizing: border-box;
    font-size: 15px;
    line-height: 20px;
    font-weight: normal;
    text-align: left;
    padding: 8px 8px;
    background-color: var(--premblue);
    color: #fff;    
    margin-bottom:20px;
    border-radius: 3px;
}

.btncont
{
  width:100%;
  box-sizing: border-box;
  text-align: center;
}

.StepProgress_cont
{
    width:100%;
    box-sizing: border-box;
    margin-bottom: 20px;
    padding:0px 8px;
}

.igeny_pageheader
{
    width:100%;
    box-sizing: border-box;
    margin-top:10px;
}

.igeny_pageheader_col1
{
    width:50%;
    box-sizing: border-box;
    display:inline-block;
    vertical-align: top;
}

.igeny_pageheader_col2
{
    width:50%;
    box-sizing: border-box;
    display:inline-block;
    vertical-align: top;
    text-align: right;
    padding-right: 8px;
    padding-top:30px;
}

.btn
{
  display: inline-block;
  font-size: 13px;
  line-height: 16px;
  font-family: 'CmsDefault';
  font-weight: normal;
  text-align: center;  
  background-color:var(--premblue);
  color:#fff;
  padding:8px 8px;
  cursor:pointer;
  border-radius: 2px;
  margin: 2px;
  min-width: 120px;

}

.btn:hover
{
  background-color: var(--premgreen);
}

.btn_icon
{
    margin-right:4px;
}

.btn_text
{
    display:inline;
}

.btn_gray
{
    background-color: #ddd;
    color: #444;;
}

.btn_gray:hover
{
    background-color: var(--premgreen);
    color: #fff;;
}




.filelist_cont {
    width: 100%;
    box-sizing: border-box;
    font-family: "CmsDefault";
    font-size: 15px;
    line-height: 18px;    
    color:var(--premblue);
    display: inline-block;
    border-bottom: solid 0px #ccc;
    padding-bottom: 4px;
    margin-bottom: 4px;
    text-align: center;
}

.file_for 
{
    width: 310px;
    box-sizing: border-box;
    display: inline-block;
    border:solid 1px #ccc;
    border-radius: 2px;
    margin:5px;
    box-shadow: rgb(221, 221, 221) 2px 2px 4px;
    position: relative;
}

.file_for:hover
{
    background-color: #f6f6f6;
}

.file_thumb
{
    width: 100%;
    cursor:pointer;
    text-align: center;
    padding: 5px;
    width:300px;
    height:220px;
    position: relative;
}

.file_footer
{
    width: 100%;
    box-sizing: border-box;
    background-color: #f0f0f0;
    border-top:solid 1px #ccc;
    height: 40px;
    padding:4px;
}

.file_filename
{
    width: 100%;
    box-sizing: border-box;
    font-size: 13px;
    line-height: 16px;
    text-align: left;
    text-overflow: ellipsis;
    white-space: nowrap;    
    overflow: hidden;
}

.file_filesize
{
    width: 100%;
    box-sizing: border-box;
    font-size: 13px;
    line-height: 16px;
    text-align: left;
    text-overflow: ellipsis;
    white-space: nowrap;    
    overflow: hidden;
}

.file_delete
{
    width:30px;
    background-color: var(--premblue);
    color: #fff;
    position:absolute;
    right:-1px;
    top:-1px;
    text-align: center;
    padding: 8px;
    font-size: 16px;
    line-height: 16px;
    border-radius: 2px;
    cursor:pointer;
    z-index: 500;
    border-top-left-radius: 0px;
    border-bottom-left-radius: 0px;
}

.file_delete:hover
{
    background-color: var(--premgreen);
}

.UjIdopont_cont
{
    width: 100%;
    box-sizing: border-box;
    max-width: 600px;
    margin: 0px auto;
    padding: 4px;
    border: solid 1px #ccc;
    -webkit-box-shadow: rgb(221, 221, 221) 2px 2px 4px;
    box-shadow: rgb(221, 221, 221) 2px 2px 4px;
    background-position: 0px 22px;
    border-radius: 3px;    
}

.UjIdopont_mezo
{
    width:50%;
    box-sizing: border-box;
    display: inline-block;
    vertical-align: top;
    padding: 5px;    
}

.infotext
{
    width:100%;
    box-sizing: border-box;
}

.idopont_cont
{
    width:100%;
    box-sizing: border-box;
}

.idopont_item
{
    width:100%;
    box-sizing: border-box;
    padding: 8px 4px;
    border:solid 1px #ccc;
    border-radius: 3px;
    margin-bottom: 10px;
    background-color: #f6f6f6;
    max-width: 600px;
    margin-left: auto;
    margin-right: auto;    
    -webkit-box-shadow: #ddd 2px 2px 4px;
    box-shadow: 2px 2px 4px #ddd;    
}

.idopont_item:hover
{
    background-color: #f0f0f0;
}

.idopont_item_text
{
    width:100%;
}

.idopont_checkbox_cont
{
    width:100%;
    box-sizing: border-box;
    max-width: 2000px;
    margin-left: auto;
    margin-right: auto;
}

.igeny_pagecontent
{
    width:100%;
    box-sizing: border-box;
    margin: 0px auto;
}

.longlabel
{
    box-sizing: border-box;
    font-family: "CmsDefault", Verdana;
    font-size: 14px;
    line-height: 18px;
    color: #222;
    font-weight: bold;
    width:100%;    
}

.general_infotext
{
    width: 100%;
    box-sizing: border-box;
    font-size: 15px;
    line-height: 20px;
}

.IdopontInput_row
{
    width:100%;
    box-sizing: border-box;
    max-width: 600px;
    margin:0px auto;
}

.idopont_list_header
{
    box-sizing: border-box;
    font-size: 15px;
    line-height: 20px;
    font-weight: normal;
    text-align: left;

    background-color: var(--premgreen);
    color: #fff;
    font-weight: normal;
    display: inline-block;
    padding: 8px;
    border-radius: 3px;    
    margin-bottom: 10px;
    width:100%;
    max-width: 600px;
}


.osszesito_box_cont
{
    width:100%;
    box-sizing: border-box;
}

.osszesito_box_col
{
    width:50%;
    box-sizing: border-box;
    margin:0px;
    padding: 10px 10px 10px 0px;
    display:inline-block;
    vertical-align: top;
}

.osszesito_box_col_header
{
    width:100%;
    box-sizing: border-box;
    font-weight: 500;
}

.osszesito_box_col_content
{
    width:100%;
    box-sizing: border-box;
    font-weight: normal;
}


.igenyles_longlabel
{
    width:100%;
    box-sizing: border-box;
    font-weight: bold;
    font-size:13px;
    line-height: 16px;;
}

.kontrol_info
{
    width:100%;
    box-sizing: border-box;
    font-weight: normal;
    font-size:14px;
    line-height: 18px;
    font-family: 'CmsDefault';
    text-align: justify;
    color: #444;
}

.ellcsop_jarobeteg_megnev
{
    text-align:left; 
    font-family:'CmsDefault'; 
    font-size:15px; 
    line-height:20px; 
    color:#222;
    padding-top: 0px; 
    height: 30px; 
    font-weight: 500;    
}

.ellcsop_jarobeteg_megnev_disabled
{
    text-align:left; 
    font-family:'CmsDefault'; 
    font-size:15px; 
    line-height:20px; 
    color:#ccc;
    padding-top: 0px; 
    height: 30px; 
    font-weight: 500;    
}

.VizsgalatInfoText
{
    width:100%;
    box-sizing: border-box;
    padding: 4px;
    border: solid 1px #ccc;
    border-radius: 3px;
    background-color: #f3f4f5;
    color: #222;
    font-size: 14px;
    line-height: 18px;    
    text-align: justify;
}

.VizsgalatInfoText_Header
{
    font-size: 15px;
    line-height: 15px;
    font-weight: 500;
    color: var(--themecolor3);
    padding: 6px 6px 4px 0px;
    border-radius: 3px;
    margin: 4px 0px;    
    display:inline-block;
    box-sizing: border-box;
}

.docs_label
{
    width: 100%;
    box-sizing: border-box;
    font-weight: 500;
    text-align: center;
    color: #222;    
}

.btnEllCsopInfo
{
    font-size: 15px;
    line-height: 15px;
    color: var(--premblue);
    padding: 6px 6px 4px 6px;
    margin-left:0px;
    cursor:pointer;
}

.btnEllCsopInfo:hover
{
    color: var(--premgreen);
}

.colpad_0_8
{
    padding:0px 8px;
}

.kritikus_datum_infotext
{
    width:100%;
    box-sizing: border-box;
    font-size:15px;
    line-height: 20px;
    text-align: left;
    color:#000;
}

@media (max-width:800px)
{
    .innerform_cont
    {
        padding:0px;
    }

    .igeny_pageheader_col1
    {
        width:100%;
    }

    .igeny_pageheader_col2
    {
        width:100%;
        text-align: left;
    }

}

@media (max-width:670px)
{
    .filelist_cont
    {
        text-align: center;
    }

    .osszesito_box_col
    {
        width:100%;
        margin-bottom:10px;
    }

    .innerform_col50
    {
        width:100%;
    }

    .colpad_0_8
    {
        padding:0px;
    }

}



</style>